import { useEffect, useState } from 'react';
import useSWR from 'swr';
import useSdk from 'helpers/hooks/useSdk';
import { revalidateOptions } from 'frontastic';

type Params = { email?: string; order?: string };

const usePublicOrder = (params: Params) => {
  const [order, setOrder] = useState<any>(null); // TODO: type
  const sdk = useSdk();

  const shippingMethodsResults = useSWR(
    '/action/cart/getShippingMethods',
    sdk.composableCommerce.cart.getShippingMethods,
    revalidateOptions,
  );
  const shippingMethods = shippingMethodsResults.data?.isError ? {} : { data: shippingMethodsResults.data?.data };

  useEffect(() => {
    if (!params.email || !params.order) {
      setOrder(null);
    }
    sdk
      .callAction<any>({
        // TODO: type
        actionName: 'yggdrasil/getPublicOrder',
        payload: { email: params.email, orderId: params.order },
      })
      .then(
        (res) => {
          setOrder(res.isError ? null : res.data.order);
        },
        () => {
          setOrder(null);
        },
      );
  }, [params.email, params.order, sdk]);
  return {
    order,
    shippingMethods,
  };
};

export default usePublicOrder;
